import clsx from 'clsx'

export function Spinner({ size = 32, className }: { size?: number; className?: string }) {
  return <div className={clsx('animate-spin rounded-full border-4 border-border border-t-primary', className)} style={{ width: size, height: size }} role="status" aria-label="Loading" />
}

export function FullScreenLoader({ label }: { label?: string }) {
  return (
    <div className="flex h-full min-h-[40vh] w-full flex-col items-center justify-center gap-md bg-bg">
      <Spinner size={40} />
      {label ? <p className="text-body-sm text-text-secondary">{label}</p> : null}
    </div>
  )
}

export function EmptyState({ icon, title, subtitle, action }: { icon?: React.ReactNode; title: string; subtitle?: string; action?: React.ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center gap-sm px-md py-xl text-center">
      {icon ? <div className="mb-xs text-text-muted">{icon}</div> : null}
      <p className="text-h4 font-semibold text-text">{title}</p>
      {subtitle ? <p className="max-w-sm text-body-sm text-text-secondary">{subtitle}</p> : null}
      {action ? <div className="mt-sm">{action}</div> : null}
    </div>
  )
}
